import React from 'react';
import Designs from './designs.jsx';
import UpsellPanel from './upsell-panel.jsx';
import Settings from './settings.jsx';
import fetch from 'unfetch';

/* Import CSS */
import './editor.scss';
import './style.scss';

const { forEach, isEmpty, set, isArray } = window.lodash;
const { Fragment } = wp.element;
const { PluginSidebar, PluginSidebarMoreMenuItem } = wp.editPost;
const { registerPlugin } = wp.plugins;
// https://github.com/WordPress/gutenberg/blob/3450273fe7522101e3809b270c80a7b9a3ebcf3a/packages/compose/src/with-state/README.md
// import { withState } from '@wordpress/compose';
const { __ } = wp.i18n;

class DesignPanel extends React.Component {
	constructor( props ) {
		super( props );

		this.state = {
			importedBasic: false,
			importedPremium: false,
			importing: false,
			designLibrary: false, //window.dsgnjs.designLibrary,
			designsCount: 0,
			errorMessage: false,
			currentPanel: false,
			premiumUser: false,
		};
	}

	/**
	 * Import designs from remote server to the local website.
	 *
	 * @function importThumbnails
	 * @param  {string} setId Design set unique id.
	 * @return {void}
	 */
	importThumbnails = ( setId = 'basic' ) => {
		this.setState( { importing: true }, () => {
			fetch( window.ajaxurl, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
				},
				body:
					'action=dsgn_design_import&_wpnonce=' +
					window.dsgnjs.nonce +
					'&design_set=' +
					setId,
				credentials: 'same-origin',
			} )
				.then( response => {
					if ( response.ok ) {
						response.text().then( text => {
							if ( text !== '1' ) {
								this.setState( { errorMessage: text, importing: false } );
							} else if ( 'basic' === setId ) {
								this.setState( { importedBasic: true } );
							} else if ( 'premium' === setId ) {
								this.setState( { importedPremium: true } );
							}
						} );
					} else {
						const error = new Error( response.statusText );
						error.response = response;
						// eslint-disable-next-line no-console
						console.warn( error );
					}
				} )
				.then( () => {
					this.getLibrary();
				} );
		} );
	};

	/**
	 * Import design library data from WP database into React
	 */
	getLibrary = () => {
		fetch( window.ajaxurl, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
			},
			body: 'action=dsgn_get_library&_wpnonce=' + window.dsgnjs.nonce,
			credentials: 'same-origin',
		} )
			.then( response => {
				// return response.json();

				if ( response.ok ) {
					return response.json();
				}
				const error = new Error( response.statusText );
				error.response = response;
				// eslint-disable-next-line no-console
				console.warn( error );
			} )
			.then( json => {
				this.updateLibraryData( json );
			} );
	};

	updateLibraryData = data => {
		if ( ! isEmpty( data.basic ) ) {
			this.setState( { importedBasic: true } );
		}

		if ( ! isEmpty( data.premium ) ) {
			this.setState( { importedPremium: true } );
		}

		window.dsgnjs.designLibrary = data;

		let totalDesigns = 0;

		// Transform provided data object into the one with designs sorted by category.
		const designsByCategory = {};
		forEach( data, ( designSet, designSetId ) => {
			if ( designSet.designs.length ) {
				forEach( designSet.designs, function( design ) {
					if ( design.categories.length ) {
						forEach( design.categories, function( category ) {
							if ( ! isArray( designsByCategory[ category ] ) ) {
								set( designsByCategory, '[' + category + ']', [] );
							}

							designsByCategory[ category ].push( {
								name: design.name,
								categories: design.categories,
								setId: designSetId,
								setName: designSet.name,
								setPrice: designSet.price,
								setUrl: designSet.base_url,
							} );
						} );
					}
					totalDesigns++;
				} );
			}
		} );
		this.setState( {
			importing: false,
			designLibrary: designsByCategory,
			designsCount: totalDesigns,
		} );
	};

	componentDidMount() {
		this.updateLibraryData( window.dsgnjs.designLibrary );
		this.setPremiumUserOnLoad( window.dsgnjs.license );
	}

	deleteLibrary = () => {
		fetch( window.ajaxurl, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
			},
			body: 'action=dsgn_delete_library&_wpnonce=' + window.dsgnjs.nonce,
			credentials: 'same-origin',
		} ).then( response => {
			if ( response.ok ) {
				window.dsgnjs.designLibrary = {};
				this.setState( {
					designLibrary: false,
					designsCount: 0,
					importedBasic: false,
					importedPremium: false,
				} );
			} else {
				const error = new Error( response.statusText );
				error.response = response;
				// eslint-disable-next-line no-console
				console.warn( error );
			}
		} );
	};

	/**
	 * Set state.premiumUser flag on panel render based on data pased from php.
	 *
	 * @function setPremiumUserOnLoad
	 * @param  {object} license License data object.
	 * @return {void}
	 */
	setPremiumUserOnLoad = license => {
		if ( 'valid' === license.license ) {
			this.onPremiumUserChange( true );
		} else {
			this.onPremiumUserChange( false );
		}
	};

	/**
	 * Update state.premiumUser from the data sent by the LicenseSettigs panel.
	 */
	/**
	 * @function onPremiumUserChange
	 * @param  {boolean} newState True for premium user, otherwise regular user.
	 * @return {void}
	 */
	onPremiumUserChange = newState => {
		this.setState( { premiumUser: newState } );
	};

	switchPanels = panelId => {
		this.setState( { currentPanel: panelId } );
	};

	render() {
		const {
			designsCount,
			designLibrary,
			importing,
			importedBasic,
			importedPremium,
			errorMessage,
		} = this.state;

		return (
			<Fragment>
				<PluginSidebarMoreMenuItem target="design">
					{ __( 'Design Library' ) }
				</PluginSidebarMoreMenuItem>
				<PluginSidebar name="design" title="Design Library">
					<ul className="sidebar__panel-tabs">
						<li>
							<button
								onClick={ () => this.switchPanels( false ) }
								className={
									'edit-post-sidebar__panel-tab ' +
									( this.state.currentPanel ? '' : 'is-active' )
								}
								aria-label={ __( 'Designs' ) }
								data-label={ __( 'Designs' ) }
							>
								{ __( 'Designs' ) }
							</button>
						</li>
						<li>
							<button
								onClick={ () => this.switchPanels( 'styles' ) }
								className={
									'edit-post-sidebar__panel-tab ' +
									( 'styles' === this.state.currentPanel ? 'is-active' : '' )
								}
								aria-label={ __( 'Styles' ) }
								data-label={ __( 'Styles' ) }
							>
								{ __( 'Styles' ) }
							</button>
						</li>
						<li>
							<button
								onClick={ () => this.switchPanels( 'settings' ) }
								className={
									'edit-post-sidebar__panel-tab ' +
									( 'settings' === this.state.currentPanel ? 'is-active' : '' )
								}
								aria-label={ __( 'Settings' ) }
								data-label={ __( 'Settings' ) }
							>
								{ __( 'Settings' ) }
							</button>
						</li>
					</ul>

					{ ! this.state.currentPanel && (
						<UpsellPanel
							designsCount={ designsCount }
							importedBasic={ importedBasic }
							importedPremium={ importedPremium }
							importing={ importing }
							errorMessage={ errorMessage }
							importThumbnails={ this.importThumbnails }
							premiumUser={ this.state.premiumUser }
						/>
					) }
					{ ! this.state.currentPanel && ! isEmpty( designLibrary ) && (
						<Designs data={ designLibrary } />
					) }
					{ ! this.state.currentPanel && isEmpty( designLibrary ) && (
						<a
							href="https://wpdesignhub.com/pro/?utm_source=plugin-ui&utm_medium=sidebar&utm_campaign=installer-empty-state&utm_campaign=installer-empty-state"
							target="_blank"
							rel="noreferrer noopener"
							className="dsgn__empty-state"
						>
							<img
								src={ window.dsgnjs.pluginUrl + '/assets/bunnya.png' }
								alt=""
							/>
						</a>
					) }

					{ 'styles' === this.state.currentPanel && (
						<a
							href="/wp-admin/plugin-install.php?s=StylistWp&tab=search&type=term"
							target="_blank"
							rel="noreferrer noopener"
							className="dsgn__stylist"
						>
							<img
								src={ window.dsgnjs.pluginUrl + '/assets/styling-tab.png' }
								alt=""
							/>
						</a>
					) }
					{ 'settings' === this.state.currentPanel && (
						<Settings
							onPremiumUserChange={ this.onPremiumUserChange }
							premiumUser={ this.state.premiumUser }
							importThumbnails={ this.importThumbnails }
							importing={ this.state.importing }
							importedPremium={ this.state.importedPremium }
							importedBasic={ this.state.importedBasic }
							deleteLibrary={ this.deleteLibrary }
							designsCount={ this.state.designsCount }
						/>
					) }
				</PluginSidebar>
			</Fragment>
		);
	}
}

registerPlugin( 'design', {
	icon: 'carrot',
	render: DesignPanel,
} );



// WEBPACK FOOTER //
// ./src/plugin.jsx